module.exports = __webpack_public_path__ + "static/media/bank.03dcb169.svg";